// The "Create a passkey" prompt after a password sign-in (#132).
//
// The login page asks for it; the default layout, which is what the user lands
// on, takes the request and decides whether to show it. Both halves live in
// sessionStorage, so the prompt is per tab session — like the auth token — and
// "Not now" lasts until the tab closes.

/** Set by the login page after a password sign-in that could have used a passkey. */
export const PASSKEY_NUDGE_REQUESTED_KEY = 'passkeyNudgeRequested'
/** Set by "Not now" (or by a spec that wants no prompt). */
export const PASSKEY_NUDGE_DISMISSED_KEY = 'passkeyNudgeDismissed'

function storage(): Storage | undefined {
  return typeof sessionStorage === 'undefined' ? undefined : sessionStorage
}

export function requestPasskeyNudge(): void {
  storage()?.setItem(PASSKEY_NUDGE_REQUESTED_KEY, '1')
}

/**
 * Whether to consider prompting now. Consumes the request, so a reload or a
 * second layout mount does not prompt again.
 */
export function takePasskeyNudge(): boolean {
  const s = storage()
  if (!s?.getItem(PASSKEY_NUDGE_REQUESTED_KEY)) {
    return false
  }
  s.removeItem(PASSKEY_NUDGE_REQUESTED_KEY)
  return !s.getItem(PASSKEY_NUDGE_DISMISSED_KEY)
}

export function dismissPasskeyNudge(): void {
  storage()?.setItem(PASSKEY_NUDGE_DISMISSED_KEY, '1')
}
